
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"55","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFBD0C","fill-rule":"evenodd","fill-opacity":".773"}},[_c('path',{attrs:{"d":"M6.804 43C2.432 23.048.18 12.024.047 9.926c-1.017-13.235 14.671-13.235 13.927 0-.055 1.76-2.445 12.785-7.17 33.074z"}}),_c('circle',{attrs:{"cx":"7.5","cy":"51.5","r":"3.5"}})])])
          )
        }
      }
    